/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LoggedInRouteImport } from './routes/_loggedIn'
import { Route as LoggedInIndexRouteImport } from './routes/_loggedIn/index'
import { Route as LoggedInOrganizationsRouteImport } from './routes/_loggedIn/organizations'
import { Route as LoggedInOrganizationIdRouteImport } from './routes/_loggedIn/$organizationId'
import { Route as LoggedInOrganizationIdIndexRouteImport } from './routes/_loggedIn/$organizationId/index'
import { Route as LoggedInOrganizationIdMapRouteImport } from './routes/_loggedIn/$organizationId/_map'
import { Route as LoggedInOrganizationIdMapLayoutRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId'
import { Route as LoggedInOrganizationIdMapLayoutReportsIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/reports/index'
import { Route as LoggedInOrganizationIdMapLayoutProjectsIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/projects/index'
import { Route as LoggedInOrganizationIdMapLayoutFormsIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/forms/index'
import { Route as LoggedInOrganizationIdMapLayoutDocumentsIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/documents/index'
import { Route as LoggedInOrganizationIdMapSettingsProjectsCreateRouteImport } from './routes/_loggedIn/$organizationId/_map/settings.projects.create'
import { Route as LoggedInOrganizationIdMapLayoutDocumentsDocumentIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/documents/$documentId'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap'
import { Route as LoggedInOrganizationIdMapLayoutSettingsTeamsIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/teams/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProjectsIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/projects/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProcedureTypesIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsOrganizationIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/organization/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsIssueTypesIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/issue-types/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsFormsIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/forms/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsAssetTypesIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/asset-types/index'
import { Route as LoggedInOrganizationIdMapLayoutFormsFormIdIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/forms/$formId/index'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsTeamsCreateRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/teams/create'
import { Route as LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProcedureTypesCreateRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/create'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId'
import { Route as LoggedInOrganizationIdMapLayoutSettingsOrganizationMembersRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/organization/members'
import { Route as LoggedInOrganizationIdMapLayoutSettingsOrganizationEmailDomainsRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/organization/email-domains'
import { Route as LoggedInOrganizationIdMapLayoutSettingsIssueTypesCreateRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/issue-types/create'
import { Route as LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId'
import { Route as LoggedInOrganizationIdMapLayoutSettingsFormsCreateRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/forms/create'
import { Route as LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId'
import { Route as LoggedInOrganizationIdMapLayoutSettingsAssetTypesCreateRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/asset-types/create'
import { Route as LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId'
import { Route as LoggedInOrganizationIdMapLayoutSettingsAccountsProfileRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/accounts/profile'
import { Route as LoggedInOrganizationIdMapLayoutSettingsAccountsPreferencesRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/accounts/preferences'
import { Route as LoggedInOrganizationIdMapLayoutFormsFormIdSubmitRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/forms/$formId/submit'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapTimelineRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/timeline'
import { Route as LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/index'
import { Route as LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/forms/submissions/$formSubmissionId/index'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedure-types/index'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issue-types/index'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/index'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapImagesIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/images/index'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/index'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/documents/index'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/asset-types/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdMembersRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId/members'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdMembersRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/members'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdAttachmentsRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/attachments'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdGeneralRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/general'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdFieldsRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/fields'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdAttachmentsRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/attachments'
import { Route as LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdStatusesRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/statuses'
import { Route as LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdPrioritiesRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/priorities'
import { Route as LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIdentifiersRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/identifiers'
import { Route as LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdGeneralRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/general'
import { Route as LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdFieldsRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/fields'
import { Route as LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdAttachmentsRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/attachments'
import { Route as LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIdentifiersRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/identifiers'
import { Route as LoggedInOrganizationIdMapLayoutSettingsFormsFormIdFieldsRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/fields'
import { Route as LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdStatusesRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/statuses'
import { Route as LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIdentifiersRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/identifiers'
import { Route as LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdGeneralRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/general'
import { Route as LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdFieldsRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/fields'
import { Route as LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdAttachmentsRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/attachments'
import { Route as LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdEditRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/forms/submissions/$formSubmissionId/edit'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapProceduresProcedureIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedures/$procedureId'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesProcedureTypeIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedure-types/$procedureTypeId'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssuesIssueIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issues/$issueId'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIssueTypeIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issue-types/$issueTypeId'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesCreateRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/create'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesProcedureInitiativeIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/$procedureInitiativeId'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsDocumentIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/documents/$documentId'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetsAssetIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/assets/$assetId'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/index'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/$formId/index'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesAssetTypeIdIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/asset-types/$assetTypeId/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRevisionsProcedureTypeFieldsIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/revisions/$procedureTypeFieldsId'
import { Route as LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRevisionsIssueTypeFieldsIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/revisions/$issueTypeFieldsId'
import { Route as LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRevisionsFormRevisionIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/revisions/$formRevisionId'
import { Route as LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRevisionsAssetTypeFieldsIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/revisions/$assetTypeFieldsId'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdSubmitRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/$formId/submit'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/index'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdIndexRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/submissions/$formSubmissionId/index'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdFieldsRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/fields'
import { Route as LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdEditRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/submissions/$formSubmissionId/edit'
import { Route as LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRevisionsProcedureStepFieldsIdRouteImport } from './routes/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/revisions/$procedureStepFieldsId'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoggedInRoute = LoggedInRouteImport.update({
  id: '/_loggedIn',
  getParentRoute: () => rootRouteImport,
} as any)
const LoggedInIndexRoute = LoggedInIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoggedInRoute,
} as any)
const LoggedInOrganizationsRoute = LoggedInOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => LoggedInRoute,
} as any)
const LoggedInOrganizationIdRoute = LoggedInOrganizationIdRouteImport.update({
  id: '/$organizationId',
  path: '/$organizationId',
  getParentRoute: () => LoggedInRoute,
} as any)
const LoggedInOrganizationIdIndexRoute =
  LoggedInOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LoggedInOrganizationIdRoute,
  } as any)
const LoggedInOrganizationIdMapRoute =
  LoggedInOrganizationIdMapRouteImport.update({
    id: '/_map',
    getParentRoute: () => LoggedInOrganizationIdRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutRoute =
  LoggedInOrganizationIdMapLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => LoggedInOrganizationIdMapRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutProjectIdRoute =
  LoggedInOrganizationIdMapLayoutProjectIdRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutReportsIndexRoute =
  LoggedInOrganizationIdMapLayoutReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutProjectsIndexRoute =
  LoggedInOrganizationIdMapLayoutProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutFormsIndexRoute =
  LoggedInOrganizationIdMapLayoutFormsIndexRouteImport.update({
    id: '/forms/',
    path: '/forms/',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutDocumentsIndexRoute =
  LoggedInOrganizationIdMapLayoutDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapSettingsProjectsCreateRoute =
  LoggedInOrganizationIdMapSettingsProjectsCreateRouteImport.update({
    id: '/settings/projects/create',
    path: '/settings/projects/create',
    getParentRoute: () => LoggedInOrganizationIdMapRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutDocumentsDocumentIdRoute =
  LoggedInOrganizationIdMapLayoutDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapRouteImport.update({
    id: '/_projectMap',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutProjectIdRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsTeamsIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsTeamsIndexRouteImport.update({
    id: '/settings/teams/',
    path: '/settings/teams/',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsProjectsIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsProjectsIndexRouteImport.update({
    id: '/settings/projects/',
    path: '/settings/projects/',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesIndexRouteImport.update({
    id: '/settings/procedure-types/',
    path: '/settings/procedure-types/',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsOrganizationIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsOrganizationIndexRouteImport.update({
    id: '/settings/organization/',
    path: '/settings/organization/',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsIssueTypesIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIndexRouteImport.update({
    id: '/settings/issue-types/',
    path: '/settings/issue-types/',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsFormsIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsFormsIndexRouteImport.update({
    id: '/settings/forms/',
    path: '/settings/forms/',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsAssetTypesIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesIndexRouteImport.update({
    id: '/settings/asset-types/',
    path: '/settings/asset-types/',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutFormsFormIdIndexRoute =
  LoggedInOrganizationIdMapLayoutFormsFormIdIndexRouteImport.update({
    id: '/forms/$formId/',
    path: '/forms/$formId/',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapIndexRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsTeamsCreateRoute =
  LoggedInOrganizationIdMapLayoutSettingsTeamsCreateRouteImport.update({
    id: '/settings/teams/create',
    path: '/settings/teams/create',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRoute =
  LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRouteImport.update({
    id: '/settings/teams/$teamId',
    path: '/settings/teams/$teamId',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRoute =
  LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRouteImport.update({
    id: '/settings/projects/$projectId',
    path: '/settings/projects/$projectId',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesCreateRoute =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesCreateRouteImport.update(
    {
      id: '/settings/procedure-types/create',
      path: '/settings/procedure-types/create',
      getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRouteImport.update(
    {
      id: '/settings/procedure-types/$procedureTypeId',
      path: '/settings/procedure-types/$procedureTypeId',
      getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsOrganizationMembersRoute =
  LoggedInOrganizationIdMapLayoutSettingsOrganizationMembersRouteImport.update({
    id: '/settings/organization/members',
    path: '/settings/organization/members',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsOrganizationEmailDomainsRoute =
  LoggedInOrganizationIdMapLayoutSettingsOrganizationEmailDomainsRouteImport.update(
    {
      id: '/settings/organization/email-domains',
      path: '/settings/organization/email-domains',
      getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsIssueTypesCreateRoute =
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesCreateRouteImport.update({
    id: '/settings/issue-types/create',
    path: '/settings/issue-types/create',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute =
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRouteImport.update(
    {
      id: '/settings/issue-types/$issueTypeId',
      path: '/settings/issue-types/$issueTypeId',
      getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsFormsCreateRoute =
  LoggedInOrganizationIdMapLayoutSettingsFormsCreateRouteImport.update({
    id: '/settings/forms/create',
    path: '/settings/forms/create',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRoute =
  LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRouteImport.update({
    id: '/settings/forms/$formId',
    path: '/settings/forms/$formId',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsAssetTypesCreateRoute =
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesCreateRouteImport.update({
    id: '/settings/asset-types/create',
    path: '/settings/asset-types/create',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute =
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRouteImport.update(
    {
      id: '/settings/asset-types/$assetTypeId',
      path: '/settings/asset-types/$assetTypeId',
      getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsAccountsProfileRoute =
  LoggedInOrganizationIdMapLayoutSettingsAccountsProfileRouteImport.update({
    id: '/settings/accounts/profile',
    path: '/settings/accounts/profile',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsAccountsPreferencesRoute =
  LoggedInOrganizationIdMapLayoutSettingsAccountsPreferencesRouteImport.update({
    id: '/settings/accounts/preferences',
    path: '/settings/accounts/preferences',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutFormsFormIdSubmitRoute =
  LoggedInOrganizationIdMapLayoutFormsFormIdSubmitRouteImport.update({
    id: '/forms/$formId/submit',
    path: '/forms/$formId/submit',
    getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapTimelineRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () =>
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdIndexRoute =
  LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdIndexRouteImport.update(
    {
      id: '/forms/submissions/$formSubmissionId/',
      path: '/forms/submissions/$formSubmissionId/',
      getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesIndexRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesIndexRouteImport.update(
    {
      id: '/procedure-types/',
      path: '/procedure-types/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIndexRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIndexRouteImport.update(
    {
      id: '/issue-types/',
      path: '/issue-types/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesIndexRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesIndexRouteImport.update(
    {
      id: '/initiatives/',
      path: '/initiatives/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapImagesIndexRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapImagesIndexRouteImport.update(
    {
      id: '/images/',
      path: '/images/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsIndexRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsIndexRouteImport.update(
    {
      id: '/forms/',
      path: '/forms/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsIndexRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsIndexRouteImport.update(
    {
      id: '/documents/',
      path: '/documents/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesIndexRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesIndexRouteImport.update(
    {
      id: '/asset-types/',
      path: '/asset-types/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdMembersRoute =
  LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () =>
      LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdMembersRoute =
  LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdMembersRouteImport.update(
    {
      id: '/members',
      path: '/members',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdAttachmentsRoute =
  LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdAttachmentsRouteImport.update(
    {
      id: '/attachments',
      path: '/attachments',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdGeneralRoute =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdGeneralRouteImport.update(
    {
      id: '/general',
      path: '/general',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdFieldsRoute =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdFieldsRouteImport.update(
    {
      id: '/fields',
      path: '/fields',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdAttachmentsRoute =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdAttachmentsRouteImport.update(
    {
      id: '/attachments',
      path: '/attachments',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdStatusesRoute =
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdStatusesRouteImport.update(
    {
      id: '/statuses',
      path: '/statuses',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdPrioritiesRoute =
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdPrioritiesRouteImport.update(
    {
      id: '/priorities',
      path: '/priorities',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIdentifiersRoute =
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIdentifiersRouteImport.update(
    {
      id: '/identifiers',
      path: '/identifiers',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdGeneralRoute =
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdGeneralRouteImport.update(
    {
      id: '/general',
      path: '/general',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdFieldsRoute =
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdFieldsRouteImport.update(
    {
      id: '/fields',
      path: '/fields',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdAttachmentsRoute =
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdAttachmentsRouteImport.update(
    {
      id: '/attachments',
      path: '/attachments',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIdentifiersRoute =
  LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIdentifiersRouteImport.update(
    {
      id: '/identifiers',
      path: '/identifiers',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsFormsFormIdFieldsRoute =
  LoggedInOrganizationIdMapLayoutSettingsFormsFormIdFieldsRouteImport.update({
    id: '/fields',
    path: '/fields',
    getParentRoute: () =>
      LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRoute,
  } as any)
const LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdStatusesRoute =
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdStatusesRouteImport.update(
    {
      id: '/statuses',
      path: '/statuses',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIdentifiersRoute =
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIdentifiersRouteImport.update(
    {
      id: '/identifiers',
      path: '/identifiers',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdGeneralRoute =
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdGeneralRouteImport.update(
    {
      id: '/general',
      path: '/general',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdFieldsRoute =
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdFieldsRouteImport.update(
    {
      id: '/fields',
      path: '/fields',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdAttachmentsRoute =
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdAttachmentsRouteImport.update(
    {
      id: '/attachments',
      path: '/attachments',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdEditRoute =
  LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdEditRouteImport.update(
    {
      id: '/forms/submissions/$formSubmissionId/edit',
      path: '/forms/submissions/$formSubmissionId/edit',
      getParentRoute: () => LoggedInOrganizationIdMapLayoutRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapProceduresProcedureIdRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapProceduresProcedureIdRouteImport.update(
    {
      id: '/procedures/$procedureId',
      path: '/procedures/$procedureId',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesProcedureTypeIdRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesProcedureTypeIdRouteImport.update(
    {
      id: '/procedure-types/$procedureTypeId',
      path: '/procedure-types/$procedureTypeId',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssuesIssueIdRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssuesIssueIdRouteImport.update(
    {
      id: '/issues/$issueId',
      path: '/issues/$issueId',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIssueTypeIdRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIssueTypeIdRouteImport.update(
    {
      id: '/issue-types/$issueTypeId',
      path: '/issue-types/$issueTypeId',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesCreateRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesCreateRouteImport.update(
    {
      id: '/initiatives/create',
      path: '/initiatives/create',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesProcedureInitiativeIdRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesProcedureInitiativeIdRouteImport.update(
    {
      id: '/initiatives/$procedureInitiativeId',
      path: '/initiatives/$procedureInitiativeId',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsDocumentIdRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsDocumentIdRouteImport.update(
    {
      id: '/documents/$documentId',
      path: '/documents/$documentId',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetsAssetIdRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetsAssetIdRouteImport.update(
    {
      id: '/assets/$assetId',
      path: '/assets/$assetId',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsIndexRouteImport.update(
    {
      id: '/steps/',
      path: '/steps/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdIndexRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdIndexRouteImport.update(
    {
      id: '/forms/$formId/',
      path: '/forms/$formId/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesAssetTypeIdIndexRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesAssetTypeIdIndexRouteImport.update(
    {
      id: '/asset-types/$assetTypeId/',
      path: '/asset-types/$assetTypeId/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRoute =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRouteImport.update(
    {
      id: '/steps/$procedureStepId',
      path: '/steps/$procedureStepId',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRevisionsProcedureTypeFieldsIdRoute =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRevisionsProcedureTypeFieldsIdRouteImport.update(
    {
      id: '/revisions/$procedureTypeFieldsId',
      path: '/revisions/$procedureTypeFieldsId',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRevisionsIssueTypeFieldsIdRoute =
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRevisionsIssueTypeFieldsIdRouteImport.update(
    {
      id: '/revisions/$issueTypeFieldsId',
      path: '/revisions/$issueTypeFieldsId',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRevisionsFormRevisionIdRoute =
  LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRevisionsFormRevisionIdRouteImport.update(
    {
      id: '/revisions/$formRevisionId',
      path: '/revisions/$formRevisionId',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRevisionsAssetTypeFieldsIdRoute =
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRevisionsAssetTypeFieldsIdRouteImport.update(
    {
      id: '/revisions/$assetTypeFieldsId',
      path: '/revisions/$assetTypeFieldsId',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdSubmitRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdSubmitRouteImport.update(
    {
      id: '/forms/$formId/submit',
      path: '/forms/$formId/submit',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdIndexRoute =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdIndexRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdIndexRouteImport.update(
    {
      id: '/forms/submissions/$formSubmissionId/',
      path: '/forms/submissions/$formSubmissionId/',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdFieldsRoute =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdFieldsRouteImport.update(
    {
      id: '/fields',
      path: '/fields',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdEditRoute =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdEditRouteImport.update(
    {
      id: '/forms/submissions/$formSubmissionId/edit',
      path: '/forms/submissions/$formSubmissionId/edit',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute,
    } as any,
  )
const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRevisionsProcedureStepFieldsIdRoute =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRevisionsProcedureStepFieldsIdRouteImport.update(
    {
      id: '/revisions/$procedureStepFieldsId',
      path: '/revisions/$procedureStepFieldsId',
      getParentRoute: () =>
        LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof LoggedInIndexRoute
  '/login': typeof LoginRoute
  '/verify-email': typeof VerifyEmailRoute
  '/$organizationId': typeof LoggedInOrganizationIdMapLayoutRouteWithChildren
  '/organizations': typeof LoggedInOrganizationsRoute
  '/$organizationId/': typeof LoggedInOrganizationIdIndexRoute
  '/$organizationId/$projectId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRouteWithChildren
  '/$organizationId/documents/$documentId': typeof LoggedInOrganizationIdMapLayoutDocumentsDocumentIdRoute
  '/$organizationId/settings/projects/create': typeof LoggedInOrganizationIdMapSettingsProjectsCreateRoute
  '/$organizationId/documents/': typeof LoggedInOrganizationIdMapLayoutDocumentsIndexRoute
  '/$organizationId/forms/': typeof LoggedInOrganizationIdMapLayoutFormsIndexRoute
  '/$organizationId/projects/': typeof LoggedInOrganizationIdMapLayoutProjectsIndexRoute
  '/$organizationId/reports/': typeof LoggedInOrganizationIdMapLayoutReportsIndexRoute
  '/$organizationId/$projectId/timeline': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapTimelineRoute
  '/$organizationId/forms/$formId/submit': typeof LoggedInOrganizationIdMapLayoutFormsFormIdSubmitRoute
  '/$organizationId/settings/accounts/preferences': typeof LoggedInOrganizationIdMapLayoutSettingsAccountsPreferencesRoute
  '/$organizationId/settings/accounts/profile': typeof LoggedInOrganizationIdMapLayoutSettingsAccountsProfileRoute
  '/$organizationId/settings/asset-types/$assetTypeId': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRouteWithChildren
  '/$organizationId/settings/asset-types/create': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesCreateRoute
  '/$organizationId/settings/forms/$formId': typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRouteWithChildren
  '/$organizationId/settings/forms/create': typeof LoggedInOrganizationIdMapLayoutSettingsFormsCreateRoute
  '/$organizationId/settings/issue-types/$issueTypeId': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRouteWithChildren
  '/$organizationId/settings/issue-types/create': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesCreateRoute
  '/$organizationId/settings/organization/email-domains': typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationEmailDomainsRoute
  '/$organizationId/settings/organization/members': typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationMembersRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRouteWithChildren
  '/$organizationId/settings/procedure-types/create': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesCreateRoute
  '/$organizationId/settings/projects/$projectId': typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRouteWithChildren
  '/$organizationId/settings/teams/$teamId': typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRouteWithChildren
  '/$organizationId/settings/teams/create': typeof LoggedInOrganizationIdMapLayoutSettingsTeamsCreateRoute
  '/$organizationId/$projectId/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIndexRoute
  '/$organizationId/forms/$formId/': typeof LoggedInOrganizationIdMapLayoutFormsFormIdIndexRoute
  '/$organizationId/settings/asset-types/': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesIndexRoute
  '/$organizationId/settings/forms/': typeof LoggedInOrganizationIdMapLayoutSettingsFormsIndexRoute
  '/$organizationId/settings/issue-types/': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIndexRoute
  '/$organizationId/settings/organization/': typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationIndexRoute
  '/$organizationId/settings/procedure-types/': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesIndexRoute
  '/$organizationId/settings/projects/': typeof LoggedInOrganizationIdMapLayoutSettingsProjectsIndexRoute
  '/$organizationId/settings/teams/': typeof LoggedInOrganizationIdMapLayoutSettingsTeamsIndexRoute
  '/$organizationId/$projectId/assets/$assetId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetsAssetIdRoute
  '/$organizationId/$projectId/documents/$documentId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsDocumentIdRoute
  '/$organizationId/$projectId/initiatives/$procedureInitiativeId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesProcedureInitiativeIdRoute
  '/$organizationId/$projectId/initiatives/create': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesCreateRoute
  '/$organizationId/$projectId/issue-types/$issueTypeId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIssueTypeIdRoute
  '/$organizationId/$projectId/issues/$issueId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssuesIssueIdRoute
  '/$organizationId/$projectId/procedure-types/$procedureTypeId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesProcedureTypeIdRoute
  '/$organizationId/$projectId/procedures/$procedureId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProceduresProcedureIdRoute
  '/$organizationId/forms/submissions/$formSubmissionId/edit': typeof LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdEditRoute
  '/$organizationId/settings/asset-types/$assetTypeId/attachments': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdAttachmentsRoute
  '/$organizationId/settings/asset-types/$assetTypeId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdFieldsRoute
  '/$organizationId/settings/asset-types/$assetTypeId/general': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdGeneralRoute
  '/$organizationId/settings/asset-types/$assetTypeId/identifiers': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIdentifiersRoute
  '/$organizationId/settings/asset-types/$assetTypeId/statuses': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdStatusesRoute
  '/$organizationId/settings/forms/$formId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdFieldsRoute
  '/$organizationId/settings/forms/$formId/identifiers': typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIdentifiersRoute
  '/$organizationId/settings/issue-types/$issueTypeId/attachments': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdAttachmentsRoute
  '/$organizationId/settings/issue-types/$issueTypeId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdFieldsRoute
  '/$organizationId/settings/issue-types/$issueTypeId/general': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdGeneralRoute
  '/$organizationId/settings/issue-types/$issueTypeId/identifiers': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIdentifiersRoute
  '/$organizationId/settings/issue-types/$issueTypeId/priorities': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdPrioritiesRoute
  '/$organizationId/settings/issue-types/$issueTypeId/statuses': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdStatusesRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/attachments': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdAttachmentsRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdFieldsRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/general': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdGeneralRoute
  '/$organizationId/settings/projects/$projectId/attachments': typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdAttachmentsRoute
  '/$organizationId/settings/projects/$projectId/members': typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdMembersRoute
  '/$organizationId/settings/teams/$teamId/members': typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdMembersRoute
  '/$organizationId/$projectId/asset-types/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesIndexRoute
  '/$organizationId/$projectId/documents/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsIndexRoute
  '/$organizationId/$projectId/forms/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsIndexRoute
  '/$organizationId/$projectId/images/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapImagesIndexRoute
  '/$organizationId/$projectId/initiatives/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesIndexRoute
  '/$organizationId/$projectId/issue-types/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIndexRoute
  '/$organizationId/$projectId/procedure-types/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesIndexRoute
  '/$organizationId/forms/submissions/$formSubmissionId/': typeof LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdIndexRoute
  '/$organizationId/settings/asset-types/$assetTypeId/': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIndexRoute
  '/$organizationId/settings/forms/$formId/': typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIndexRoute
  '/$organizationId/settings/issue-types/$issueTypeId/': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIndexRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdIndexRoute
  '/$organizationId/settings/projects/$projectId/': typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdIndexRoute
  '/$organizationId/settings/teams/$teamId/': typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdIndexRoute
  '/$organizationId/$projectId/forms/$formId/submit': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdSubmitRoute
  '/$organizationId/settings/asset-types/$assetTypeId/revisions/$assetTypeFieldsId': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRevisionsAssetTypeFieldsIdRoute
  '/$organizationId/settings/forms/$formId/revisions/$formRevisionId': typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRevisionsFormRevisionIdRoute
  '/$organizationId/settings/issue-types/$issueTypeId/revisions/$issueTypeFieldsId': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRevisionsIssueTypeFieldsIdRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/revisions/$procedureTypeFieldsId': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRevisionsProcedureTypeFieldsIdRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRouteWithChildren
  '/$organizationId/$projectId/asset-types/$assetTypeId/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesAssetTypeIdIndexRoute
  '/$organizationId/$projectId/forms/$formId/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdIndexRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/steps/': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsIndexRoute
  '/$organizationId/$projectId/forms/submissions/$formSubmissionId/edit': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdEditRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdFieldsRoute
  '/$organizationId/$projectId/forms/submissions/$formSubmissionId/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdIndexRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdIndexRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/revisions/$procedureStepFieldsId': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRevisionsProcedureStepFieldsIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/verify-email': typeof VerifyEmailRoute
  '/organizations': typeof LoggedInOrganizationsRoute
  '/': typeof LoggedInIndexRoute
  '/$organizationId': typeof LoggedInOrganizationIdMapLayoutRouteWithChildren
  '/$organizationId/$projectId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIndexRoute
  '/$organizationId/documents/$documentId': typeof LoggedInOrganizationIdMapLayoutDocumentsDocumentIdRoute
  '/$organizationId/settings/projects/create': typeof LoggedInOrganizationIdMapSettingsProjectsCreateRoute
  '/$organizationId/documents': typeof LoggedInOrganizationIdMapLayoutDocumentsIndexRoute
  '/$organizationId/forms': typeof LoggedInOrganizationIdMapLayoutFormsIndexRoute
  '/$organizationId/projects': typeof LoggedInOrganizationIdMapLayoutProjectsIndexRoute
  '/$organizationId/reports': typeof LoggedInOrganizationIdMapLayoutReportsIndexRoute
  '/$organizationId/$projectId/timeline': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapTimelineRoute
  '/$organizationId/forms/$formId/submit': typeof LoggedInOrganizationIdMapLayoutFormsFormIdSubmitRoute
  '/$organizationId/settings/accounts/preferences': typeof LoggedInOrganizationIdMapLayoutSettingsAccountsPreferencesRoute
  '/$organizationId/settings/accounts/profile': typeof LoggedInOrganizationIdMapLayoutSettingsAccountsProfileRoute
  '/$organizationId/settings/asset-types/create': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesCreateRoute
  '/$organizationId/settings/forms/create': typeof LoggedInOrganizationIdMapLayoutSettingsFormsCreateRoute
  '/$organizationId/settings/issue-types/create': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesCreateRoute
  '/$organizationId/settings/organization/email-domains': typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationEmailDomainsRoute
  '/$organizationId/settings/organization/members': typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationMembersRoute
  '/$organizationId/settings/procedure-types/create': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesCreateRoute
  '/$organizationId/settings/teams/create': typeof LoggedInOrganizationIdMapLayoutSettingsTeamsCreateRoute
  '/$organizationId/forms/$formId': typeof LoggedInOrganizationIdMapLayoutFormsFormIdIndexRoute
  '/$organizationId/settings/asset-types': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesIndexRoute
  '/$organizationId/settings/forms': typeof LoggedInOrganizationIdMapLayoutSettingsFormsIndexRoute
  '/$organizationId/settings/issue-types': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIndexRoute
  '/$organizationId/settings/organization': typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationIndexRoute
  '/$organizationId/settings/procedure-types': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesIndexRoute
  '/$organizationId/settings/projects': typeof LoggedInOrganizationIdMapLayoutSettingsProjectsIndexRoute
  '/$organizationId/settings/teams': typeof LoggedInOrganizationIdMapLayoutSettingsTeamsIndexRoute
  '/$organizationId/$projectId/assets/$assetId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetsAssetIdRoute
  '/$organizationId/$projectId/documents/$documentId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsDocumentIdRoute
  '/$organizationId/$projectId/initiatives/$procedureInitiativeId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesProcedureInitiativeIdRoute
  '/$organizationId/$projectId/initiatives/create': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesCreateRoute
  '/$organizationId/$projectId/issue-types/$issueTypeId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIssueTypeIdRoute
  '/$organizationId/$projectId/issues/$issueId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssuesIssueIdRoute
  '/$organizationId/$projectId/procedure-types/$procedureTypeId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesProcedureTypeIdRoute
  '/$organizationId/$projectId/procedures/$procedureId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProceduresProcedureIdRoute
  '/$organizationId/forms/submissions/$formSubmissionId/edit': typeof LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdEditRoute
  '/$organizationId/settings/asset-types/$assetTypeId/attachments': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdAttachmentsRoute
  '/$organizationId/settings/asset-types/$assetTypeId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdFieldsRoute
  '/$organizationId/settings/asset-types/$assetTypeId/general': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdGeneralRoute
  '/$organizationId/settings/asset-types/$assetTypeId/identifiers': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIdentifiersRoute
  '/$organizationId/settings/asset-types/$assetTypeId/statuses': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdStatusesRoute
  '/$organizationId/settings/forms/$formId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdFieldsRoute
  '/$organizationId/settings/forms/$formId/identifiers': typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIdentifiersRoute
  '/$organizationId/settings/issue-types/$issueTypeId/attachments': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdAttachmentsRoute
  '/$organizationId/settings/issue-types/$issueTypeId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdFieldsRoute
  '/$organizationId/settings/issue-types/$issueTypeId/general': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdGeneralRoute
  '/$organizationId/settings/issue-types/$issueTypeId/identifiers': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIdentifiersRoute
  '/$organizationId/settings/issue-types/$issueTypeId/priorities': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdPrioritiesRoute
  '/$organizationId/settings/issue-types/$issueTypeId/statuses': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdStatusesRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/attachments': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdAttachmentsRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdFieldsRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/general': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdGeneralRoute
  '/$organizationId/settings/projects/$projectId/attachments': typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdAttachmentsRoute
  '/$organizationId/settings/projects/$projectId/members': typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdMembersRoute
  '/$organizationId/settings/teams/$teamId/members': typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdMembersRoute
  '/$organizationId/$projectId/asset-types': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesIndexRoute
  '/$organizationId/$projectId/documents': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsIndexRoute
  '/$organizationId/$projectId/forms': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsIndexRoute
  '/$organizationId/$projectId/images': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapImagesIndexRoute
  '/$organizationId/$projectId/initiatives': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesIndexRoute
  '/$organizationId/$projectId/issue-types': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIndexRoute
  '/$organizationId/$projectId/procedure-types': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesIndexRoute
  '/$organizationId/forms/submissions/$formSubmissionId': typeof LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdIndexRoute
  '/$organizationId/settings/asset-types/$assetTypeId': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIndexRoute
  '/$organizationId/settings/forms/$formId': typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIndexRoute
  '/$organizationId/settings/issue-types/$issueTypeId': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIndexRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdIndexRoute
  '/$organizationId/settings/projects/$projectId': typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdIndexRoute
  '/$organizationId/settings/teams/$teamId': typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdIndexRoute
  '/$organizationId/$projectId/forms/$formId/submit': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdSubmitRoute
  '/$organizationId/settings/asset-types/$assetTypeId/revisions/$assetTypeFieldsId': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRevisionsAssetTypeFieldsIdRoute
  '/$organizationId/settings/forms/$formId/revisions/$formRevisionId': typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRevisionsFormRevisionIdRoute
  '/$organizationId/settings/issue-types/$issueTypeId/revisions/$issueTypeFieldsId': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRevisionsIssueTypeFieldsIdRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/revisions/$procedureTypeFieldsId': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRevisionsProcedureTypeFieldsIdRoute
  '/$organizationId/$projectId/asset-types/$assetTypeId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesAssetTypeIdIndexRoute
  '/$organizationId/$projectId/forms/$formId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdIndexRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/steps': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsIndexRoute
  '/$organizationId/$projectId/forms/submissions/$formSubmissionId/edit': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdEditRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdFieldsRoute
  '/$organizationId/$projectId/forms/submissions/$formSubmissionId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdIndexRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdIndexRoute
  '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/revisions/$procedureStepFieldsId': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRevisionsProcedureStepFieldsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_loggedIn': typeof LoggedInRouteWithChildren
  '/login': typeof LoginRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_loggedIn/$organizationId': typeof LoggedInOrganizationIdRouteWithChildren
  '/_loggedIn/organizations': typeof LoggedInOrganizationsRoute
  '/_loggedIn/': typeof LoggedInIndexRoute
  '/_loggedIn/$organizationId/_map': typeof LoggedInOrganizationIdMapRouteWithChildren
  '/_loggedIn/$organizationId/': typeof LoggedInOrganizationIdIndexRoute
  '/_loggedIn/$organizationId/_map/_layout': typeof LoggedInOrganizationIdMapLayoutRouteWithChildren
  '/_loggedIn/$organizationId/_map/_layout/$projectId': typeof LoggedInOrganizationIdMapLayoutProjectIdRouteWithChildren
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRouteWithChildren
  '/_loggedIn/$organizationId/_map/_layout/documents/$documentId': typeof LoggedInOrganizationIdMapLayoutDocumentsDocumentIdRoute
  '/_loggedIn/$organizationId/_map/settings/projects/create': typeof LoggedInOrganizationIdMapSettingsProjectsCreateRoute
  '/_loggedIn/$organizationId/_map/_layout/documents/': typeof LoggedInOrganizationIdMapLayoutDocumentsIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/forms/': typeof LoggedInOrganizationIdMapLayoutFormsIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/projects/': typeof LoggedInOrganizationIdMapLayoutProjectsIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/reports/': typeof LoggedInOrganizationIdMapLayoutReportsIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/timeline': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapTimelineRoute
  '/_loggedIn/$organizationId/_map/_layout/forms/$formId/submit': typeof LoggedInOrganizationIdMapLayoutFormsFormIdSubmitRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/accounts/preferences': typeof LoggedInOrganizationIdMapLayoutSettingsAccountsPreferencesRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/accounts/profile': typeof LoggedInOrganizationIdMapLayoutSettingsAccountsProfileRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRouteWithChildren
  '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/create': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesCreateRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId': typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRouteWithChildren
  '/_loggedIn/$organizationId/_map/_layout/settings/forms/create': typeof LoggedInOrganizationIdMapLayoutSettingsFormsCreateRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRouteWithChildren
  '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/create': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesCreateRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/organization/email-domains': typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationEmailDomainsRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/organization/members': typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationMembersRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRouteWithChildren
  '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/create': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesCreateRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId': typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRouteWithChildren
  '/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId': typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRouteWithChildren
  '/_loggedIn/$organizationId/_map/_layout/settings/teams/create': typeof LoggedInOrganizationIdMapLayoutSettingsTeamsCreateRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/forms/$formId/': typeof LoggedInOrganizationIdMapLayoutFormsFormIdIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/forms/': typeof LoggedInOrganizationIdMapLayoutSettingsFormsIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/organization/': typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/projects/': typeof LoggedInOrganizationIdMapLayoutSettingsProjectsIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/teams/': typeof LoggedInOrganizationIdMapLayoutSettingsTeamsIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/assets/$assetId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetsAssetIdRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/documents/$documentId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsDocumentIdRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/$procedureInitiativeId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesProcedureInitiativeIdRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/create': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesCreateRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issue-types/$issueTypeId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIssueTypeIdRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issues/$issueId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssuesIssueIdRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedure-types/$procedureTypeId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesProcedureTypeIdRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedures/$procedureId': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProceduresProcedureIdRoute
  '/_loggedIn/$organizationId/_map/_layout/forms/submissions/$formSubmissionId/edit': typeof LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdEditRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/attachments': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdAttachmentsRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdFieldsRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/general': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdGeneralRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/identifiers': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIdentifiersRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/statuses': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdStatusesRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdFieldsRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/identifiers': typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIdentifiersRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/attachments': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdAttachmentsRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdFieldsRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/general': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdGeneralRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/identifiers': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIdentifiersRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/priorities': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdPrioritiesRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/statuses': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdStatusesRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/attachments': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdAttachmentsRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdFieldsRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/general': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdGeneralRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/attachments': typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdAttachmentsRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/members': typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdMembersRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId/members': typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdMembersRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/asset-types/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/documents/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/images/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapImagesIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issue-types/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedure-types/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/forms/submissions/$formSubmissionId/': typeof LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/': typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/': typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId/': typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/$formId/submit': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdSubmitRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/revisions/$assetTypeFieldsId': typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRevisionsAssetTypeFieldsIdRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/revisions/$formRevisionId': typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRevisionsFormRevisionIdRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/revisions/$issueTypeFieldsId': typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRevisionsIssueTypeFieldsIdRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/revisions/$procedureTypeFieldsId': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRevisionsProcedureTypeFieldsIdRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRouteWithChildren
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/asset-types/$assetTypeId/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesAssetTypeIdIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/$formId/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/submissions/$formSubmissionId/edit': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdEditRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/fields': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdFieldsRoute
  '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/submissions/$formSubmissionId/': typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdIndexRoute
  '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/revisions/$procedureStepFieldsId': typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRevisionsProcedureStepFieldsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/verify-email'
    | '/$organizationId'
    | '/organizations'
    | '/$organizationId/'
    | '/$organizationId/$projectId'
    | '/$organizationId/documents/$documentId'
    | '/$organizationId/settings/projects/create'
    | '/$organizationId/documents/'
    | '/$organizationId/forms/'
    | '/$organizationId/projects/'
    | '/$organizationId/reports/'
    | '/$organizationId/$projectId/timeline'
    | '/$organizationId/forms/$formId/submit'
    | '/$organizationId/settings/accounts/preferences'
    | '/$organizationId/settings/accounts/profile'
    | '/$organizationId/settings/asset-types/$assetTypeId'
    | '/$organizationId/settings/asset-types/create'
    | '/$organizationId/settings/forms/$formId'
    | '/$organizationId/settings/forms/create'
    | '/$organizationId/settings/issue-types/$issueTypeId'
    | '/$organizationId/settings/issue-types/create'
    | '/$organizationId/settings/organization/email-domains'
    | '/$organizationId/settings/organization/members'
    | '/$organizationId/settings/procedure-types/$procedureTypeId'
    | '/$organizationId/settings/procedure-types/create'
    | '/$organizationId/settings/projects/$projectId'
    | '/$organizationId/settings/teams/$teamId'
    | '/$organizationId/settings/teams/create'
    | '/$organizationId/$projectId/'
    | '/$organizationId/forms/$formId/'
    | '/$organizationId/settings/asset-types/'
    | '/$organizationId/settings/forms/'
    | '/$organizationId/settings/issue-types/'
    | '/$organizationId/settings/organization/'
    | '/$organizationId/settings/procedure-types/'
    | '/$organizationId/settings/projects/'
    | '/$organizationId/settings/teams/'
    | '/$organizationId/$projectId/assets/$assetId'
    | '/$organizationId/$projectId/documents/$documentId'
    | '/$organizationId/$projectId/initiatives/$procedureInitiativeId'
    | '/$organizationId/$projectId/initiatives/create'
    | '/$organizationId/$projectId/issue-types/$issueTypeId'
    | '/$organizationId/$projectId/issues/$issueId'
    | '/$organizationId/$projectId/procedure-types/$procedureTypeId'
    | '/$organizationId/$projectId/procedures/$procedureId'
    | '/$organizationId/forms/submissions/$formSubmissionId/edit'
    | '/$organizationId/settings/asset-types/$assetTypeId/attachments'
    | '/$organizationId/settings/asset-types/$assetTypeId/fields'
    | '/$organizationId/settings/asset-types/$assetTypeId/general'
    | '/$organizationId/settings/asset-types/$assetTypeId/identifiers'
    | '/$organizationId/settings/asset-types/$assetTypeId/statuses'
    | '/$organizationId/settings/forms/$formId/fields'
    | '/$organizationId/settings/forms/$formId/identifiers'
    | '/$organizationId/settings/issue-types/$issueTypeId/attachments'
    | '/$organizationId/settings/issue-types/$issueTypeId/fields'
    | '/$organizationId/settings/issue-types/$issueTypeId/general'
    | '/$organizationId/settings/issue-types/$issueTypeId/identifiers'
    | '/$organizationId/settings/issue-types/$issueTypeId/priorities'
    | '/$organizationId/settings/issue-types/$issueTypeId/statuses'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/attachments'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/fields'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/general'
    | '/$organizationId/settings/projects/$projectId/attachments'
    | '/$organizationId/settings/projects/$projectId/members'
    | '/$organizationId/settings/teams/$teamId/members'
    | '/$organizationId/$projectId/asset-types/'
    | '/$organizationId/$projectId/documents/'
    | '/$organizationId/$projectId/forms/'
    | '/$organizationId/$projectId/images/'
    | '/$organizationId/$projectId/initiatives/'
    | '/$organizationId/$projectId/issue-types/'
    | '/$organizationId/$projectId/procedure-types/'
    | '/$organizationId/forms/submissions/$formSubmissionId/'
    | '/$organizationId/settings/asset-types/$assetTypeId/'
    | '/$organizationId/settings/forms/$formId/'
    | '/$organizationId/settings/issue-types/$issueTypeId/'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/'
    | '/$organizationId/settings/projects/$projectId/'
    | '/$organizationId/settings/teams/$teamId/'
    | '/$organizationId/$projectId/forms/$formId/submit'
    | '/$organizationId/settings/asset-types/$assetTypeId/revisions/$assetTypeFieldsId'
    | '/$organizationId/settings/forms/$formId/revisions/$formRevisionId'
    | '/$organizationId/settings/issue-types/$issueTypeId/revisions/$issueTypeFieldsId'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/revisions/$procedureTypeFieldsId'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId'
    | '/$organizationId/$projectId/asset-types/$assetTypeId/'
    | '/$organizationId/$projectId/forms/$formId/'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/steps/'
    | '/$organizationId/$projectId/forms/submissions/$formSubmissionId/edit'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/fields'
    | '/$organizationId/$projectId/forms/submissions/$formSubmissionId/'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/revisions/$procedureStepFieldsId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/verify-email'
    | '/organizations'
    | '/'
    | '/$organizationId'
    | '/$organizationId/$projectId'
    | '/$organizationId/documents/$documentId'
    | '/$organizationId/settings/projects/create'
    | '/$organizationId/documents'
    | '/$organizationId/forms'
    | '/$organizationId/projects'
    | '/$organizationId/reports'
    | '/$organizationId/$projectId/timeline'
    | '/$organizationId/forms/$formId/submit'
    | '/$organizationId/settings/accounts/preferences'
    | '/$organizationId/settings/accounts/profile'
    | '/$organizationId/settings/asset-types/create'
    | '/$organizationId/settings/forms/create'
    | '/$organizationId/settings/issue-types/create'
    | '/$organizationId/settings/organization/email-domains'
    | '/$organizationId/settings/organization/members'
    | '/$organizationId/settings/procedure-types/create'
    | '/$organizationId/settings/teams/create'
    | '/$organizationId/forms/$formId'
    | '/$organizationId/settings/asset-types'
    | '/$organizationId/settings/forms'
    | '/$organizationId/settings/issue-types'
    | '/$organizationId/settings/organization'
    | '/$organizationId/settings/procedure-types'
    | '/$organizationId/settings/projects'
    | '/$organizationId/settings/teams'
    | '/$organizationId/$projectId/assets/$assetId'
    | '/$organizationId/$projectId/documents/$documentId'
    | '/$organizationId/$projectId/initiatives/$procedureInitiativeId'
    | '/$organizationId/$projectId/initiatives/create'
    | '/$organizationId/$projectId/issue-types/$issueTypeId'
    | '/$organizationId/$projectId/issues/$issueId'
    | '/$organizationId/$projectId/procedure-types/$procedureTypeId'
    | '/$organizationId/$projectId/procedures/$procedureId'
    | '/$organizationId/forms/submissions/$formSubmissionId/edit'
    | '/$organizationId/settings/asset-types/$assetTypeId/attachments'
    | '/$organizationId/settings/asset-types/$assetTypeId/fields'
    | '/$organizationId/settings/asset-types/$assetTypeId/general'
    | '/$organizationId/settings/asset-types/$assetTypeId/identifiers'
    | '/$organizationId/settings/asset-types/$assetTypeId/statuses'
    | '/$organizationId/settings/forms/$formId/fields'
    | '/$organizationId/settings/forms/$formId/identifiers'
    | '/$organizationId/settings/issue-types/$issueTypeId/attachments'
    | '/$organizationId/settings/issue-types/$issueTypeId/fields'
    | '/$organizationId/settings/issue-types/$issueTypeId/general'
    | '/$organizationId/settings/issue-types/$issueTypeId/identifiers'
    | '/$organizationId/settings/issue-types/$issueTypeId/priorities'
    | '/$organizationId/settings/issue-types/$issueTypeId/statuses'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/attachments'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/fields'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/general'
    | '/$organizationId/settings/projects/$projectId/attachments'
    | '/$organizationId/settings/projects/$projectId/members'
    | '/$organizationId/settings/teams/$teamId/members'
    | '/$organizationId/$projectId/asset-types'
    | '/$organizationId/$projectId/documents'
    | '/$organizationId/$projectId/forms'
    | '/$organizationId/$projectId/images'
    | '/$organizationId/$projectId/initiatives'
    | '/$organizationId/$projectId/issue-types'
    | '/$organizationId/$projectId/procedure-types'
    | '/$organizationId/forms/submissions/$formSubmissionId'
    | '/$organizationId/settings/asset-types/$assetTypeId'
    | '/$organizationId/settings/forms/$formId'
    | '/$organizationId/settings/issue-types/$issueTypeId'
    | '/$organizationId/settings/procedure-types/$procedureTypeId'
    | '/$organizationId/settings/projects/$projectId'
    | '/$organizationId/settings/teams/$teamId'
    | '/$organizationId/$projectId/forms/$formId/submit'
    | '/$organizationId/settings/asset-types/$assetTypeId/revisions/$assetTypeFieldsId'
    | '/$organizationId/settings/forms/$formId/revisions/$formRevisionId'
    | '/$organizationId/settings/issue-types/$issueTypeId/revisions/$issueTypeFieldsId'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/revisions/$procedureTypeFieldsId'
    | '/$organizationId/$projectId/asset-types/$assetTypeId'
    | '/$organizationId/$projectId/forms/$formId'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/steps'
    | '/$organizationId/$projectId/forms/submissions/$formSubmissionId/edit'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/fields'
    | '/$organizationId/$projectId/forms/submissions/$formSubmissionId'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId'
    | '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/revisions/$procedureStepFieldsId'
  id:
    | '__root__'
    | '/_loggedIn'
    | '/login'
    | '/verify-email'
    | '/_loggedIn/$organizationId'
    | '/_loggedIn/organizations'
    | '/_loggedIn/'
    | '/_loggedIn/$organizationId/_map'
    | '/_loggedIn/$organizationId/'
    | '/_loggedIn/$organizationId/_map/_layout'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap'
    | '/_loggedIn/$organizationId/_map/_layout/documents/$documentId'
    | '/_loggedIn/$organizationId/_map/settings/projects/create'
    | '/_loggedIn/$organizationId/_map/_layout/documents/'
    | '/_loggedIn/$organizationId/_map/_layout/forms/'
    | '/_loggedIn/$organizationId/_map/_layout/projects/'
    | '/_loggedIn/$organizationId/_map/_layout/reports/'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/timeline'
    | '/_loggedIn/$organizationId/_map/_layout/forms/$formId/submit'
    | '/_loggedIn/$organizationId/_map/_layout/settings/accounts/preferences'
    | '/_loggedIn/$organizationId/_map/_layout/settings/accounts/profile'
    | '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId'
    | '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/create'
    | '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId'
    | '/_loggedIn/$organizationId/_map/_layout/settings/forms/create'
    | '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId'
    | '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/create'
    | '/_loggedIn/$organizationId/_map/_layout/settings/organization/email-domains'
    | '/_loggedIn/$organizationId/_map/_layout/settings/organization/members'
    | '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId'
    | '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/create'
    | '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId'
    | '/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId'
    | '/_loggedIn/$organizationId/_map/_layout/settings/teams/create'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/'
    | '/_loggedIn/$organizationId/_map/_layout/forms/$formId/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/forms/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/organization/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/projects/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/teams/'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/assets/$assetId'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/documents/$documentId'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/$procedureInitiativeId'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/create'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issue-types/$issueTypeId'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issues/$issueId'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedure-types/$procedureTypeId'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedures/$procedureId'
    | '/_loggedIn/$organizationId/_map/_layout/forms/submissions/$formSubmissionId/edit'
    | '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/attachments'
    | '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/fields'
    | '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/general'
    | '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/identifiers'
    | '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/statuses'
    | '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/fields'
    | '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/identifiers'
    | '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/attachments'
    | '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/fields'
    | '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/general'
    | '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/identifiers'
    | '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/priorities'
    | '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/statuses'
    | '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/attachments'
    | '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/fields'
    | '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/general'
    | '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/attachments'
    | '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/members'
    | '/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId/members'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/asset-types/'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/documents/'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/images/'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issue-types/'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedure-types/'
    | '/_loggedIn/$organizationId/_map/_layout/forms/submissions/$formSubmissionId/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId/'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/$formId/submit'
    | '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/revisions/$assetTypeFieldsId'
    | '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/revisions/$formRevisionId'
    | '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/revisions/$issueTypeFieldsId'
    | '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/revisions/$procedureTypeFieldsId'
    | '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/asset-types/$assetTypeId/'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/$formId/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/submissions/$formSubmissionId/edit'
    | '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/fields'
    | '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/submissions/$formSubmissionId/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/'
    | '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/revisions/$procedureStepFieldsId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LoggedInRoute: typeof LoggedInRouteWithChildren
  LoginRoute: typeof LoginRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_loggedIn': {
      id: '/_loggedIn'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LoggedInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_loggedIn/': {
      id: '/_loggedIn/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LoggedInIndexRouteImport
      parentRoute: typeof LoggedInRoute
    }
    '/_loggedIn/organizations': {
      id: '/_loggedIn/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof LoggedInOrganizationsRouteImport
      parentRoute: typeof LoggedInRoute
    }
    '/_loggedIn/$organizationId': {
      id: '/_loggedIn/$organizationId'
      path: '/$organizationId'
      fullPath: '/$organizationId'
      preLoaderRoute: typeof LoggedInOrganizationIdRouteImport
      parentRoute: typeof LoggedInRoute
    }
    '/_loggedIn/$organizationId/': {
      id: '/_loggedIn/$organizationId/'
      path: '/'
      fullPath: '/$organizationId/'
      preLoaderRoute: typeof LoggedInOrganizationIdIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdRoute
    }
    '/_loggedIn/$organizationId/_map': {
      id: '/_loggedIn/$organizationId/_map'
      path: ''
      fullPath: '/$organizationId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapRouteImport
      parentRoute: typeof LoggedInOrganizationIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout': {
      id: '/_loggedIn/$organizationId/_map/_layout'
      path: ''
      fullPath: '/$organizationId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId'
      path: '/$projectId'
      fullPath: '/$organizationId/$projectId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/reports/': {
      id: '/_loggedIn/$organizationId/_map/_layout/reports/'
      path: '/reports'
      fullPath: '/$organizationId/reports/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutReportsIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/projects/': {
      id: '/_loggedIn/$organizationId/_map/_layout/projects/'
      path: '/projects'
      fullPath: '/$organizationId/projects/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectsIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/forms/': {
      id: '/_loggedIn/$organizationId/_map/_layout/forms/'
      path: '/forms'
      fullPath: '/$organizationId/forms/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutFormsIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/documents/': {
      id: '/_loggedIn/$organizationId/_map/_layout/documents/'
      path: '/documents'
      fullPath: '/$organizationId/documents/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutDocumentsIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/settings/projects/create': {
      id: '/_loggedIn/$organizationId/_map/settings/projects/create'
      path: '/settings/projects/create'
      fullPath: '/$organizationId/settings/projects/create'
      preLoaderRoute: typeof LoggedInOrganizationIdMapSettingsProjectsCreateRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/documents/$documentId': {
      id: '/_loggedIn/$organizationId/_map/_layout/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/$organizationId/documents/$documentId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutDocumentsDocumentIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap'
      path: ''
      fullPath: '/$organizationId/$projectId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/teams/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/teams/'
      path: '/settings/teams'
      fullPath: '/$organizationId/settings/teams/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsTeamsIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/projects/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/projects/'
      path: '/settings/projects'
      fullPath: '/$organizationId/settings/projects/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProjectsIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/'
      path: '/settings/procedure-types'
      fullPath: '/$organizationId/settings/procedure-types/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/organization/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/organization/'
      path: '/settings/organization'
      fullPath: '/$organizationId/settings/organization/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/'
      path: '/settings/issue-types'
      fullPath: '/$organizationId/settings/issue-types/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/forms/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/forms/'
      path: '/settings/forms'
      fullPath: '/$organizationId/settings/forms/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/'
      path: '/settings/asset-types'
      fullPath: '/$organizationId/settings/asset-types/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/forms/$formId/': {
      id: '/_loggedIn/$organizationId/_map/_layout/forms/$formId/'
      path: '/forms/$formId'
      fullPath: '/$organizationId/forms/$formId/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutFormsFormIdIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/'
      path: '/'
      fullPath: '/$organizationId/$projectId/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/teams/create': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/teams/create'
      path: '/settings/teams/create'
      fullPath: '/$organizationId/settings/teams/create'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsTeamsCreateRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId'
      path: '/settings/teams/$teamId'
      fullPath: '/$organizationId/settings/teams/$teamId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId'
      path: '/settings/projects/$projectId'
      fullPath: '/$organizationId/settings/projects/$projectId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/create': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/create'
      path: '/settings/procedure-types/create'
      fullPath: '/$organizationId/settings/procedure-types/create'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesCreateRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId'
      path: '/settings/procedure-types/$procedureTypeId'
      fullPath: '/$organizationId/settings/procedure-types/$procedureTypeId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/organization/members': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/organization/members'
      path: '/settings/organization/members'
      fullPath: '/$organizationId/settings/organization/members'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationMembersRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/organization/email-domains': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/organization/email-domains'
      path: '/settings/organization/email-domains'
      fullPath: '/$organizationId/settings/organization/email-domains'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationEmailDomainsRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/create': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/create'
      path: '/settings/issue-types/create'
      fullPath: '/$organizationId/settings/issue-types/create'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesCreateRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId'
      path: '/settings/issue-types/$issueTypeId'
      fullPath: '/$organizationId/settings/issue-types/$issueTypeId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/forms/create': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/forms/create'
      path: '/settings/forms/create'
      fullPath: '/$organizationId/settings/forms/create'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsCreateRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId'
      path: '/settings/forms/$formId'
      fullPath: '/$organizationId/settings/forms/$formId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/create': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/create'
      path: '/settings/asset-types/create'
      fullPath: '/$organizationId/settings/asset-types/create'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesCreateRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId'
      path: '/settings/asset-types/$assetTypeId'
      fullPath: '/$organizationId/settings/asset-types/$assetTypeId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/accounts/profile': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/accounts/profile'
      path: '/settings/accounts/profile'
      fullPath: '/$organizationId/settings/accounts/profile'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAccountsProfileRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/accounts/preferences': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/accounts/preferences'
      path: '/settings/accounts/preferences'
      fullPath: '/$organizationId/settings/accounts/preferences'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAccountsPreferencesRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/forms/$formId/submit': {
      id: '/_loggedIn/$organizationId/_map/_layout/forms/$formId/submit'
      path: '/forms/$formId/submit'
      fullPath: '/$organizationId/forms/$formId/submit'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutFormsFormIdSubmitRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/timeline': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/timeline'
      path: '/timeline'
      fullPath: '/$organizationId/$projectId/timeline'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapTimelineRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId/'
      path: '/'
      fullPath: '/$organizationId/settings/teams/$teamId/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/'
      path: '/'
      fullPath: '/$organizationId/settings/projects/$projectId/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/'
      path: '/'
      fullPath: '/$organizationId/settings/procedure-types/$procedureTypeId/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/'
      path: '/'
      fullPath: '/$organizationId/settings/issue-types/$issueTypeId/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/'
      path: '/'
      fullPath: '/$organizationId/settings/forms/$formId/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/'
      path: '/'
      fullPath: '/$organizationId/settings/asset-types/$assetTypeId/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/forms/submissions/$formSubmissionId/': {
      id: '/_loggedIn/$organizationId/_map/_layout/forms/submissions/$formSubmissionId/'
      path: '/forms/submissions/$formSubmissionId'
      fullPath: '/$organizationId/forms/submissions/$formSubmissionId/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedure-types/': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedure-types/'
      path: '/procedure-types'
      fullPath: '/$organizationId/$projectId/procedure-types/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issue-types/': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issue-types/'
      path: '/issue-types'
      fullPath: '/$organizationId/$projectId/issue-types/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/'
      path: '/initiatives'
      fullPath: '/$organizationId/$projectId/initiatives/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/images/': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/images/'
      path: '/images'
      fullPath: '/$organizationId/$projectId/images/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapImagesIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/'
      path: '/forms'
      fullPath: '/$organizationId/$projectId/forms/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/documents/': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/documents/'
      path: '/documents'
      fullPath: '/$organizationId/$projectId/documents/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/asset-types/': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/asset-types/'
      path: '/asset-types'
      fullPath: '/$organizationId/$projectId/asset-types/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId/members': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId/members'
      path: '/members'
      fullPath: '/$organizationId/settings/teams/$teamId/members'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdMembersRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/members': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/members'
      path: '/members'
      fullPath: '/$organizationId/settings/projects/$projectId/members'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdMembersRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/attachments': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/attachments'
      path: '/attachments'
      fullPath: '/$organizationId/settings/projects/$projectId/attachments'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdAttachmentsRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/general': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/general'
      path: '/general'
      fullPath: '/$organizationId/settings/procedure-types/$procedureTypeId/general'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdGeneralRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/fields': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/fields'
      path: '/fields'
      fullPath: '/$organizationId/settings/procedure-types/$procedureTypeId/fields'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdFieldsRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/attachments': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/attachments'
      path: '/attachments'
      fullPath: '/$organizationId/settings/procedure-types/$procedureTypeId/attachments'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdAttachmentsRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/statuses': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/statuses'
      path: '/statuses'
      fullPath: '/$organizationId/settings/issue-types/$issueTypeId/statuses'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdStatusesRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/priorities': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/priorities'
      path: '/priorities'
      fullPath: '/$organizationId/settings/issue-types/$issueTypeId/priorities'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdPrioritiesRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/identifiers': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/identifiers'
      path: '/identifiers'
      fullPath: '/$organizationId/settings/issue-types/$issueTypeId/identifiers'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIdentifiersRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/general': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/general'
      path: '/general'
      fullPath: '/$organizationId/settings/issue-types/$issueTypeId/general'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdGeneralRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/fields': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/fields'
      path: '/fields'
      fullPath: '/$organizationId/settings/issue-types/$issueTypeId/fields'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdFieldsRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/attachments': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/attachments'
      path: '/attachments'
      fullPath: '/$organizationId/settings/issue-types/$issueTypeId/attachments'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdAttachmentsRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/identifiers': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/identifiers'
      path: '/identifiers'
      fullPath: '/$organizationId/settings/forms/$formId/identifiers'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIdentifiersRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/fields': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/fields'
      path: '/fields'
      fullPath: '/$organizationId/settings/forms/$formId/fields'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdFieldsRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/statuses': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/statuses'
      path: '/statuses'
      fullPath: '/$organizationId/settings/asset-types/$assetTypeId/statuses'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdStatusesRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/identifiers': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/identifiers'
      path: '/identifiers'
      fullPath: '/$organizationId/settings/asset-types/$assetTypeId/identifiers'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIdentifiersRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/general': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/general'
      path: '/general'
      fullPath: '/$organizationId/settings/asset-types/$assetTypeId/general'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdGeneralRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/fields': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/fields'
      path: '/fields'
      fullPath: '/$organizationId/settings/asset-types/$assetTypeId/fields'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdFieldsRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/attachments': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/attachments'
      path: '/attachments'
      fullPath: '/$organizationId/settings/asset-types/$assetTypeId/attachments'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdAttachmentsRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/forms/submissions/$formSubmissionId/edit': {
      id: '/_loggedIn/$organizationId/_map/_layout/forms/submissions/$formSubmissionId/edit'
      path: '/forms/submissions/$formSubmissionId/edit'
      fullPath: '/$organizationId/forms/submissions/$formSubmissionId/edit'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdEditRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedures/$procedureId': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedures/$procedureId'
      path: '/procedures/$procedureId'
      fullPath: '/$organizationId/$projectId/procedures/$procedureId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProceduresProcedureIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedure-types/$procedureTypeId': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedure-types/$procedureTypeId'
      path: '/procedure-types/$procedureTypeId'
      fullPath: '/$organizationId/$projectId/procedure-types/$procedureTypeId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesProcedureTypeIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issues/$issueId': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issues/$issueId'
      path: '/issues/$issueId'
      fullPath: '/$organizationId/$projectId/issues/$issueId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssuesIssueIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issue-types/$issueTypeId': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issue-types/$issueTypeId'
      path: '/issue-types/$issueTypeId'
      fullPath: '/$organizationId/$projectId/issue-types/$issueTypeId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIssueTypeIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/create': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/create'
      path: '/initiatives/create'
      fullPath: '/$organizationId/$projectId/initiatives/create'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesCreateRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/$procedureInitiativeId': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/$procedureInitiativeId'
      path: '/initiatives/$procedureInitiativeId'
      fullPath: '/$organizationId/$projectId/initiatives/$procedureInitiativeId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesProcedureInitiativeIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/documents/$documentId': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/$organizationId/$projectId/documents/$documentId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsDocumentIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/assets/$assetId': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/assets/$assetId'
      path: '/assets/$assetId'
      fullPath: '/$organizationId/$projectId/assets/$assetId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetsAssetIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/'
      path: '/steps'
      fullPath: '/$organizationId/settings/procedure-types/$procedureTypeId/steps/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/$formId/': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/$formId/'
      path: '/forms/$formId'
      fullPath: '/$organizationId/$projectId/forms/$formId/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/asset-types/$assetTypeId/': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/asset-types/$assetTypeId/'
      path: '/asset-types/$assetTypeId'
      fullPath: '/$organizationId/$projectId/asset-types/$assetTypeId/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesAssetTypeIdIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId'
      path: '/steps/$procedureStepId'
      fullPath: '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/revisions/$procedureTypeFieldsId': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/revisions/$procedureTypeFieldsId'
      path: '/revisions/$procedureTypeFieldsId'
      fullPath: '/$organizationId/settings/procedure-types/$procedureTypeId/revisions/$procedureTypeFieldsId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRevisionsProcedureTypeFieldsIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/revisions/$issueTypeFieldsId': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/revisions/$issueTypeFieldsId'
      path: '/revisions/$issueTypeFieldsId'
      fullPath: '/$organizationId/settings/issue-types/$issueTypeId/revisions/$issueTypeFieldsId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRevisionsIssueTypeFieldsIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/revisions/$formRevisionId': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/revisions/$formRevisionId'
      path: '/revisions/$formRevisionId'
      fullPath: '/$organizationId/settings/forms/$formId/revisions/$formRevisionId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRevisionsFormRevisionIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/revisions/$assetTypeFieldsId': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/revisions/$assetTypeFieldsId'
      path: '/revisions/$assetTypeFieldsId'
      fullPath: '/$organizationId/settings/asset-types/$assetTypeId/revisions/$assetTypeFieldsId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRevisionsAssetTypeFieldsIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/$formId/submit': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/$formId/submit'
      path: '/forms/$formId/submit'
      fullPath: '/$organizationId/$projectId/forms/$formId/submit'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdSubmitRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/'
      path: '/'
      fullPath: '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/submissions/$formSubmissionId/': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/submissions/$formSubmissionId/'
      path: '/forms/submissions/$formSubmissionId'
      fullPath: '/$organizationId/$projectId/forms/submissions/$formSubmissionId/'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdIndexRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/fields': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/fields'
      path: '/fields'
      fullPath: '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/fields'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdFieldsRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/submissions/$formSubmissionId/edit': {
      id: '/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/submissions/$formSubmissionId/edit'
      path: '/forms/submissions/$formSubmissionId/edit'
      fullPath: '/$organizationId/$projectId/forms/submissions/$formSubmissionId/edit'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdEditRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute
    }
    '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/revisions/$procedureStepFieldsId': {
      id: '/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/revisions/$procedureStepFieldsId'
      path: '/revisions/$procedureStepFieldsId'
      fullPath: '/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/revisions/$procedureStepFieldsId'
      preLoaderRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRevisionsProcedureStepFieldsIdRouteImport
      parentRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRoute
    }
  }
}

interface LoggedInOrganizationIdMapLayoutProjectIdProjectMapRouteChildren {
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapTimelineRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapTimelineRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapIndexRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIndexRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetsAssetIdRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetsAssetIdRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsDocumentIdRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsDocumentIdRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesProcedureInitiativeIdRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesProcedureInitiativeIdRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesCreateRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesCreateRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIssueTypeIdRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIssueTypeIdRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssuesIssueIdRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssuesIssueIdRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesProcedureTypeIdRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesProcedureTypeIdRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapProceduresProcedureIdRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProceduresProcedureIdRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesIndexRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesIndexRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsIndexRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsIndexRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsIndexRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsIndexRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapImagesIndexRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapImagesIndexRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesIndexRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesIndexRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIndexRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIndexRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesIndexRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesIndexRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdSubmitRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdSubmitRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesAssetTypeIdIndexRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesAssetTypeIdIndexRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdIndexRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdIndexRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdEditRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdEditRoute
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdIndexRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdIndexRoute
}

const LoggedInOrganizationIdMapLayoutProjectIdProjectMapRouteChildren: LoggedInOrganizationIdMapLayoutProjectIdProjectMapRouteChildren =
  {
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapTimelineRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapTimelineRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapIndexRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapIndexRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetsAssetIdRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetsAssetIdRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsDocumentIdRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsDocumentIdRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesProcedureInitiativeIdRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesProcedureInitiativeIdRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesCreateRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesCreateRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIssueTypeIdRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIssueTypeIdRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssuesIssueIdRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssuesIssueIdRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesProcedureTypeIdRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesProcedureTypeIdRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapProceduresProcedureIdRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapProceduresProcedureIdRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesIndexRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesIndexRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsIndexRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapDocumentsIndexRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsIndexRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsIndexRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapImagesIndexRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapImagesIndexRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesIndexRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapInitiativesIndexRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIndexRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapIssueTypesIndexRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesIndexRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapProcedureTypesIndexRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdSubmitRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdSubmitRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesAssetTypeIdIndexRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapAssetTypesAssetTypeIdIndexRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdIndexRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsFormIdIndexRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdEditRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdEditRoute,
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdIndexRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapFormsSubmissionsFormSubmissionIdIndexRoute,
  }

const LoggedInOrganizationIdMapLayoutProjectIdProjectMapRouteWithChildren =
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute._addFileChildren(
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapRouteChildren,
  )

interface LoggedInOrganizationIdMapLayoutProjectIdRouteChildren {
  LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdProjectMapRouteWithChildren
}

const LoggedInOrganizationIdMapLayoutProjectIdRouteChildren: LoggedInOrganizationIdMapLayoutProjectIdRouteChildren =
  {
    LoggedInOrganizationIdMapLayoutProjectIdProjectMapRoute:
      LoggedInOrganizationIdMapLayoutProjectIdProjectMapRouteWithChildren,
  }

const LoggedInOrganizationIdMapLayoutProjectIdRouteWithChildren =
  LoggedInOrganizationIdMapLayoutProjectIdRoute._addFileChildren(
    LoggedInOrganizationIdMapLayoutProjectIdRouteChildren,
  )

interface LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRouteChildren {
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdAttachmentsRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdAttachmentsRoute
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdFieldsRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdFieldsRoute
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdGeneralRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdGeneralRoute
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIdentifiersRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIdentifiersRoute
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdStatusesRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdStatusesRoute
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIndexRoute
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRevisionsAssetTypeFieldsIdRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRevisionsAssetTypeFieldsIdRoute
}

const LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRouteChildren: LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRouteChildren =
  {
    LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdAttachmentsRoute:
      LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdAttachmentsRoute,
    LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdFieldsRoute:
      LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdFieldsRoute,
    LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdGeneralRoute:
      LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdGeneralRoute,
    LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIdentifiersRoute:
      LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIdentifiersRoute,
    LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdStatusesRoute:
      LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdStatusesRoute,
    LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdIndexRoute,
    LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRevisionsAssetTypeFieldsIdRoute:
      LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRevisionsAssetTypeFieldsIdRoute,
  }

const LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRouteWithChildren =
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute._addFileChildren(
    LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRouteChildren,
  )

interface LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRouteChildren {
  LoggedInOrganizationIdMapLayoutSettingsFormsFormIdFieldsRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdFieldsRoute
  LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIdentifiersRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIdentifiersRoute
  LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIndexRoute
  LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRevisionsFormRevisionIdRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRevisionsFormRevisionIdRoute
}

const LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRouteChildren: LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRouteChildren =
  {
    LoggedInOrganizationIdMapLayoutSettingsFormsFormIdFieldsRoute:
      LoggedInOrganizationIdMapLayoutSettingsFormsFormIdFieldsRoute,
    LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIdentifiersRoute:
      LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIdentifiersRoute,
    LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsFormsFormIdIndexRoute,
    LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRevisionsFormRevisionIdRoute:
      LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRevisionsFormRevisionIdRoute,
  }

const LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRouteWithChildren =
  LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRoute._addFileChildren(
    LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRouteChildren,
  )

interface LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRouteChildren {
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdAttachmentsRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdAttachmentsRoute
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdFieldsRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdFieldsRoute
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdGeneralRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdGeneralRoute
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIdentifiersRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIdentifiersRoute
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdPrioritiesRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdPrioritiesRoute
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdStatusesRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdStatusesRoute
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIndexRoute
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRevisionsIssueTypeFieldsIdRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRevisionsIssueTypeFieldsIdRoute
}

const LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRouteChildren: LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRouteChildren =
  {
    LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdAttachmentsRoute:
      LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdAttachmentsRoute,
    LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdFieldsRoute:
      LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdFieldsRoute,
    LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdGeneralRoute:
      LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdGeneralRoute,
    LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIdentifiersRoute:
      LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIdentifiersRoute,
    LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdPrioritiesRoute:
      LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdPrioritiesRoute,
    LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdStatusesRoute:
      LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdStatusesRoute,
    LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdIndexRoute,
    LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRevisionsIssueTypeFieldsIdRoute:
      LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRevisionsIssueTypeFieldsIdRoute,
  }

const LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRouteWithChildren =
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute._addFileChildren(
    LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRouteChildren,
  )

interface LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRouteChildren {
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdFieldsRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdFieldsRoute
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdIndexRoute
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRevisionsProcedureStepFieldsIdRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRevisionsProcedureStepFieldsIdRoute
}

const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRouteChildren: LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRouteChildren =
  {
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdFieldsRoute:
      LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdFieldsRoute,
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdIndexRoute,
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRevisionsProcedureStepFieldsIdRoute:
      LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRevisionsProcedureStepFieldsIdRoute,
  }

const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRouteWithChildren =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRoute._addFileChildren(
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRouteChildren,
  )

interface LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRouteChildren {
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdAttachmentsRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdAttachmentsRoute
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdFieldsRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdFieldsRoute
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdGeneralRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdGeneralRoute
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdIndexRoute
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRevisionsProcedureTypeFieldsIdRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRevisionsProcedureTypeFieldsIdRoute
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRouteWithChildren
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsIndexRoute
}

const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRouteChildren: LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRouteChildren =
  {
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdAttachmentsRoute:
      LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdAttachmentsRoute,
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdFieldsRoute:
      LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdFieldsRoute,
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdGeneralRoute:
      LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdGeneralRoute,
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdIndexRoute,
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRevisionsProcedureTypeFieldsIdRoute:
      LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRevisionsProcedureTypeFieldsIdRoute,
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRoute:
      LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsProcedureStepIdRouteWithChildren,
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdStepsIndexRoute,
  }

const LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRouteWithChildren =
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute._addFileChildren(
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRouteChildren,
  )

interface LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRouteChildren {
  LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdAttachmentsRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdAttachmentsRoute
  LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdMembersRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdMembersRoute
  LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdIndexRoute
}

const LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRouteChildren: LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRouteChildren =
  {
    LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdAttachmentsRoute:
      LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdAttachmentsRoute,
    LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdMembersRoute:
      LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdMembersRoute,
    LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdIndexRoute,
  }

const LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRouteWithChildren =
  LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRoute._addFileChildren(
    LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRouteChildren,
  )

interface LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRouteChildren {
  LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdMembersRoute: typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdMembersRoute
  LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdIndexRoute
}

const LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRouteChildren: LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRouteChildren =
  {
    LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdMembersRoute:
      LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdMembersRoute,
    LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdIndexRoute,
  }

const LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRouteWithChildren =
  LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRoute._addFileChildren(
    LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRouteChildren,
  )

interface LoggedInOrganizationIdMapLayoutRouteChildren {
  LoggedInOrganizationIdMapLayoutProjectIdRoute: typeof LoggedInOrganizationIdMapLayoutProjectIdRouteWithChildren
  LoggedInOrganizationIdMapLayoutDocumentsDocumentIdRoute: typeof LoggedInOrganizationIdMapLayoutDocumentsDocumentIdRoute
  LoggedInOrganizationIdMapLayoutDocumentsIndexRoute: typeof LoggedInOrganizationIdMapLayoutDocumentsIndexRoute
  LoggedInOrganizationIdMapLayoutFormsIndexRoute: typeof LoggedInOrganizationIdMapLayoutFormsIndexRoute
  LoggedInOrganizationIdMapLayoutProjectsIndexRoute: typeof LoggedInOrganizationIdMapLayoutProjectsIndexRoute
  LoggedInOrganizationIdMapLayoutReportsIndexRoute: typeof LoggedInOrganizationIdMapLayoutReportsIndexRoute
  LoggedInOrganizationIdMapLayoutFormsFormIdSubmitRoute: typeof LoggedInOrganizationIdMapLayoutFormsFormIdSubmitRoute
  LoggedInOrganizationIdMapLayoutSettingsAccountsPreferencesRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAccountsPreferencesRoute
  LoggedInOrganizationIdMapLayoutSettingsAccountsProfileRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAccountsProfileRoute
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRouteWithChildren
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesCreateRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesCreateRoute
  LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRouteWithChildren
  LoggedInOrganizationIdMapLayoutSettingsFormsCreateRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsCreateRoute
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRouteWithChildren
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesCreateRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesCreateRoute
  LoggedInOrganizationIdMapLayoutSettingsOrganizationEmailDomainsRoute: typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationEmailDomainsRoute
  LoggedInOrganizationIdMapLayoutSettingsOrganizationMembersRoute: typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationMembersRoute
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRouteWithChildren
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesCreateRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesCreateRoute
  LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRouteWithChildren
  LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRoute: typeof LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRouteWithChildren
  LoggedInOrganizationIdMapLayoutSettingsTeamsCreateRoute: typeof LoggedInOrganizationIdMapLayoutSettingsTeamsCreateRoute
  LoggedInOrganizationIdMapLayoutFormsFormIdIndexRoute: typeof LoggedInOrganizationIdMapLayoutFormsFormIdIndexRoute
  LoggedInOrganizationIdMapLayoutSettingsAssetTypesIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsAssetTypesIndexRoute
  LoggedInOrganizationIdMapLayoutSettingsFormsIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsFormsIndexRoute
  LoggedInOrganizationIdMapLayoutSettingsIssueTypesIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsIssueTypesIndexRoute
  LoggedInOrganizationIdMapLayoutSettingsOrganizationIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsOrganizationIndexRoute
  LoggedInOrganizationIdMapLayoutSettingsProcedureTypesIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProcedureTypesIndexRoute
  LoggedInOrganizationIdMapLayoutSettingsProjectsIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsProjectsIndexRoute
  LoggedInOrganizationIdMapLayoutSettingsTeamsIndexRoute: typeof LoggedInOrganizationIdMapLayoutSettingsTeamsIndexRoute
  LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdEditRoute: typeof LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdEditRoute
  LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdIndexRoute: typeof LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdIndexRoute
}

const LoggedInOrganizationIdMapLayoutRouteChildren: LoggedInOrganizationIdMapLayoutRouteChildren =
  {
    LoggedInOrganizationIdMapLayoutProjectIdRoute:
      LoggedInOrganizationIdMapLayoutProjectIdRouteWithChildren,
    LoggedInOrganizationIdMapLayoutDocumentsDocumentIdRoute:
      LoggedInOrganizationIdMapLayoutDocumentsDocumentIdRoute,
    LoggedInOrganizationIdMapLayoutDocumentsIndexRoute:
      LoggedInOrganizationIdMapLayoutDocumentsIndexRoute,
    LoggedInOrganizationIdMapLayoutFormsIndexRoute:
      LoggedInOrganizationIdMapLayoutFormsIndexRoute,
    LoggedInOrganizationIdMapLayoutProjectsIndexRoute:
      LoggedInOrganizationIdMapLayoutProjectsIndexRoute,
    LoggedInOrganizationIdMapLayoutReportsIndexRoute:
      LoggedInOrganizationIdMapLayoutReportsIndexRoute,
    LoggedInOrganizationIdMapLayoutFormsFormIdSubmitRoute:
      LoggedInOrganizationIdMapLayoutFormsFormIdSubmitRoute,
    LoggedInOrganizationIdMapLayoutSettingsAccountsPreferencesRoute:
      LoggedInOrganizationIdMapLayoutSettingsAccountsPreferencesRoute,
    LoggedInOrganizationIdMapLayoutSettingsAccountsProfileRoute:
      LoggedInOrganizationIdMapLayoutSettingsAccountsProfileRoute,
    LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRoute:
      LoggedInOrganizationIdMapLayoutSettingsAssetTypesAssetTypeIdRouteWithChildren,
    LoggedInOrganizationIdMapLayoutSettingsAssetTypesCreateRoute:
      LoggedInOrganizationIdMapLayoutSettingsAssetTypesCreateRoute,
    LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRoute:
      LoggedInOrganizationIdMapLayoutSettingsFormsFormIdRouteWithChildren,
    LoggedInOrganizationIdMapLayoutSettingsFormsCreateRoute:
      LoggedInOrganizationIdMapLayoutSettingsFormsCreateRoute,
    LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRoute:
      LoggedInOrganizationIdMapLayoutSettingsIssueTypesIssueTypeIdRouteWithChildren,
    LoggedInOrganizationIdMapLayoutSettingsIssueTypesCreateRoute:
      LoggedInOrganizationIdMapLayoutSettingsIssueTypesCreateRoute,
    LoggedInOrganizationIdMapLayoutSettingsOrganizationEmailDomainsRoute:
      LoggedInOrganizationIdMapLayoutSettingsOrganizationEmailDomainsRoute,
    LoggedInOrganizationIdMapLayoutSettingsOrganizationMembersRoute:
      LoggedInOrganizationIdMapLayoutSettingsOrganizationMembersRoute,
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRoute:
      LoggedInOrganizationIdMapLayoutSettingsProcedureTypesProcedureTypeIdRouteWithChildren,
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesCreateRoute:
      LoggedInOrganizationIdMapLayoutSettingsProcedureTypesCreateRoute,
    LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRoute:
      LoggedInOrganizationIdMapLayoutSettingsProjectsProjectIdRouteWithChildren,
    LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRoute:
      LoggedInOrganizationIdMapLayoutSettingsTeamsTeamIdRouteWithChildren,
    LoggedInOrganizationIdMapLayoutSettingsTeamsCreateRoute:
      LoggedInOrganizationIdMapLayoutSettingsTeamsCreateRoute,
    LoggedInOrganizationIdMapLayoutFormsFormIdIndexRoute:
      LoggedInOrganizationIdMapLayoutFormsFormIdIndexRoute,
    LoggedInOrganizationIdMapLayoutSettingsAssetTypesIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsAssetTypesIndexRoute,
    LoggedInOrganizationIdMapLayoutSettingsFormsIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsFormsIndexRoute,
    LoggedInOrganizationIdMapLayoutSettingsIssueTypesIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsIssueTypesIndexRoute,
    LoggedInOrganizationIdMapLayoutSettingsOrganizationIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsOrganizationIndexRoute,
    LoggedInOrganizationIdMapLayoutSettingsProcedureTypesIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsProcedureTypesIndexRoute,
    LoggedInOrganizationIdMapLayoutSettingsProjectsIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsProjectsIndexRoute,
    LoggedInOrganizationIdMapLayoutSettingsTeamsIndexRoute:
      LoggedInOrganizationIdMapLayoutSettingsTeamsIndexRoute,
    LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdEditRoute:
      LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdEditRoute,
    LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdIndexRoute:
      LoggedInOrganizationIdMapLayoutFormsSubmissionsFormSubmissionIdIndexRoute,
  }

const LoggedInOrganizationIdMapLayoutRouteWithChildren =
  LoggedInOrganizationIdMapLayoutRoute._addFileChildren(
    LoggedInOrganizationIdMapLayoutRouteChildren,
  )

interface LoggedInOrganizationIdMapRouteChildren {
  LoggedInOrganizationIdMapLayoutRoute: typeof LoggedInOrganizationIdMapLayoutRouteWithChildren
  LoggedInOrganizationIdMapSettingsProjectsCreateRoute: typeof LoggedInOrganizationIdMapSettingsProjectsCreateRoute
}

const LoggedInOrganizationIdMapRouteChildren: LoggedInOrganizationIdMapRouteChildren =
  {
    LoggedInOrganizationIdMapLayoutRoute:
      LoggedInOrganizationIdMapLayoutRouteWithChildren,
    LoggedInOrganizationIdMapSettingsProjectsCreateRoute:
      LoggedInOrganizationIdMapSettingsProjectsCreateRoute,
  }

const LoggedInOrganizationIdMapRouteWithChildren =
  LoggedInOrganizationIdMapRoute._addFileChildren(
    LoggedInOrganizationIdMapRouteChildren,
  )

interface LoggedInOrganizationIdRouteChildren {
  LoggedInOrganizationIdMapRoute: typeof LoggedInOrganizationIdMapRouteWithChildren
  LoggedInOrganizationIdIndexRoute: typeof LoggedInOrganizationIdIndexRoute
}

const LoggedInOrganizationIdRouteChildren: LoggedInOrganizationIdRouteChildren =
  {
    LoggedInOrganizationIdMapRoute: LoggedInOrganizationIdMapRouteWithChildren,
    LoggedInOrganizationIdIndexRoute: LoggedInOrganizationIdIndexRoute,
  }

const LoggedInOrganizationIdRouteWithChildren =
  LoggedInOrganizationIdRoute._addFileChildren(
    LoggedInOrganizationIdRouteChildren,
  )

interface LoggedInRouteChildren {
  LoggedInOrganizationIdRoute: typeof LoggedInOrganizationIdRouteWithChildren
  LoggedInOrganizationsRoute: typeof LoggedInOrganizationsRoute
  LoggedInIndexRoute: typeof LoggedInIndexRoute
}

const LoggedInRouteChildren: LoggedInRouteChildren = {
  LoggedInOrganizationIdRoute: LoggedInOrganizationIdRouteWithChildren,
  LoggedInOrganizationsRoute: LoggedInOrganizationsRoute,
  LoggedInIndexRoute: LoggedInIndexRoute,
}

const LoggedInRouteWithChildren = LoggedInRoute._addFileChildren(
  LoggedInRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  LoggedInRoute: LoggedInRouteWithChildren,
  LoginRoute: LoginRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
